module.exports = __webpack_public_path__ + "img/04_garantia.5ea3a4b9.png";